import React from 'react';
import { useParams } from 'react-router-dom';

const ProjectResources: React.FC = () => {
  const { projectId } = useParams();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Project Resources</h1>
      <p className="text-gray-600">Project ID: {projectId}</p>
      <p className="text-gray-500 mt-2">This component will be implemented in Phase 3 (Resources Tab revamp).</p>
    </div>
  );
};

export default ProjectResources; 

